var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    rx: 8,
    fill: "#FC2B38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 27.9056L22.249 40L44.8892 17",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/success-tick.a1aa5c96de38a5672bb4effa2620d66b.svg";
export { ForwardRef as ReactComponent };